define('module/tile-wall',[
    'underscore',
    'jquery',
    'cnf',
    '_pubsub',
    
    //tmpl
    'template/expandable'
], function(
        _,$,Cnf,Pubsub,
        Expandable
        ){
    'use strict';
    
    return function()
    {
        var oPubsub=new Pubsub();
        
        this.options={
            selector:{
                trigger:'.trigger-tilewall',
                triggerTile:'.trigger-tile',
                triggerHtml:'.trigger-html'
            },
            data:{
                index:'index',
                tileIndex:'tile',
                abandon:'abandon',
                notext: 'notext'
            },
            classname:{
                active:'tilewall-active',
                activeTile:'tile-active'
            },
            tween:{
                open:{
                    duration:.5,
                    ease:Power3.easeInOut
                },
                close:{
                    duration:.5,
                    ease:Power3.easeInOut
                }
            }
        };
        
        this.init=function()
        {
            this.initOptions();
            this.initEvents();
            this.initElements();
        };
        
        this.initOptions=function()
        {
            this.$tilewall=Cnf.$app.find(this.options.selector.trigger);
            this.iTilewall=this.$tilewall.length;
            this.oTilewall={};
            this.aRelation=[];
        };
        
        this.initEvents=function()
        {
            oPubsub.on(Pubsub.TRIGGER_TOGGLE_TILEWALL, _.bind(this.triggerToggleTilewall,this));
            oPubsub.on(Pubsub.VIEWPORT_CHANGE,_.bind(this.onViewportChange,this));
            oPubsub.on(Pubsub.TILEWALL_ADD_ITEM, _.bind(this.addItem, this));
        };
        
        this.initElements=function()
        {
            if(this.iTilewall<=0) {
                return;
            }
            
            for(var i=0,y=this.iTilewall;i<y;i++) {
                this.addItem(this.$tilewall.eq(i));
            }
        };
        
        this.addItem=function($item)
        {
            var index=$item.data(this.options.data.index);
                
            var oTile=$item.find(this.options.selector.triggerTile),
                    iTile=oTile.length;
            
            this.oTilewall[index]={
                $el:$item,
                $tiles:oTile,
                length:iTile,
                active:false,
                current:-1,
                busy:false,
                $expandable:null,
                $expandableHtml:null
            };
            this.aRelation.push(index);
            
            for(var m=0;m<iTile;m++) {
                oTile.eq(m)
                        .data({
                            index:index
                        })
                        .on(Cnf.click, _.debounce(_.bind(function(arg) {
                            var index=arg.$el.data(this.options.data.index);
                            
                            if(false!==this.oTilewall[index].busy) {
                                return;
                            }
                            this.oTilewall[index].busy=true;
                            
                            switch(true) {
                                case this.oTilewall[index].length===1:
                                //toggle on mobile is triggered by flickity
                                case false===Cnf.isMobile:
                                    this.toggleTilewall(arg.$el);
                                    break;
                            }
                        },this,{$el:oTile.eq(m)}),100));
            }
        }

        this.toggleTilewall=function($el)
        {
            var index=$el.data(this.options.data.index),
                    tile=$el.data(this.options.data.tileIndex),
                    create,
                    close,
                    toggle;

            //break on nodata
            if(true === $el.data('nodata')) {
                this.oTilewall[index].busy = false;
                return;
            }
            
            //toggle wall dependend of viewport
            switch(Cnf.viewport) {
                case 'desktop':
                case 'tablet':
                    toggle=(this.oTilewall[index].current>=0) && (this.oTilewall[index].current!==tile);
                    close=(this.oTilewall[index].current===tile);
                    create=(null===this.oTilewall[index].$expandable);
                    
                    //not sure anymore why to exclude tile.length=1: deactivated so far
                    //if(this.oTilewall[index].length>1) {
                    if(this.oTilewall[index].length>=1) {
                        this.triggerToggleExpandable({$el:$el, toggle:toggle, close:close, create:create});
                    } else {
                        toggle=false;
                        close=(this.oTilewall[index].active===true);
                        this.oTilewall[index].busy=false;
                    }
                    break;
                    
                case 'mobile':
                default:
                    toggle=false;
                    close=(this.oTilewall[index].active===true);
                    this.oTilewall[index].busy=false;
                    
                    _.delay(_.bind(function(index) {
                        oPubsub.trigger(Pubsub.RESIZE_FLICKITY,index);
                    },this,index),600);
                    break;
            }
            
            switch(true) {
                case true===toggle:
                    this.oTilewall[index].$tiles.eq(tile).addClass(this.options.classname.activeTile);
                    this.oTilewall[index].$tiles.eq(this.oTilewall[index].current).removeClass(this.options.classname.activeTile);
                    this.oTilewall[index].current=tile;
                    break;
                    
                case true===close:
                    this.oTilewall[index].active=false;
                    this.oTilewall[index].$el.removeClass(this.options.classname.active);
                    this.oTilewall[index].$tiles.eq(this.oTilewall[index].current).removeClass(this.options.classname.activeTile);
                    this.oTilewall[index].current=-1;
                    break;
                    
                case false===close:
                    this.oTilewall[index].active=true;
                    this.oTilewall[index].$el.addClass(this.options.classname.active);
                    this.oTilewall[index].$tiles.eq(tile).addClass(this.options.classname.activeTile);
                    this.oTilewall[index].current=tile;
                    break;
            }
        };
        
        this.triggerToggleTilewall=function($el)
        {
            this.toggleTilewall($el);
        };
        
        this.triggerToggleExpandable=function(arg)
        {
            var index=arg.$el.data(this.options.data.index);
            
            switch(true) {
                case true===arg.toggle:
                    this.closeExpandable(index).done(_.bind(this.toggleExpandable,this,arg.$el));
                    break;
                    
                case true===arg.close:
                    this.closeExpandable(index).done(_.bind(function(){
                        this.oTilewall[index].busy=false;
                        this.disposeExpandable(index);
                    },this));
                    break;
                    
                case true===arg.create:
                    this.createExpandable(arg.$el);
                    break;
            }
        };
        
        this.createExpandable=function($el)
        {
            var index=$el.data(this.options.data.index),
                    tileIndex=$el.data(this.options.data.tileIndex),
                    notext = $el.data(this.options.data.notext),
                    divider=(true===Cnf.isTablet) ? 3 : 4,
                    rest=(tileIndex % divider),
                    diff=divider -rest,
                    insertIndex=Math.min((tileIndex +diff), this.oTilewall[index].length) -1;
            
            this.oTilewall[index].$expandable=$(Expandable({
                html:$el.find(this.options.selector.triggerHtml).html()
            })).insertAfter(this.oTilewall[index].$tiles.eq(insertIndex));
            
            this.oTilewall[index].$expandableHtml=this.oTilewall[index].$expandable.find(this.options.selector.triggerHtml);
            
            this.openExpandable({index:index,tileIndex:tileIndex, notext: notext});
        };
        
        this.openExpandable=function(arg)
        {
            var abandon=false;
            if(arg.tileIndex >= (this.oTilewall[arg.index].length -1 -((this.oTilewall[arg.index].length -1) % ((true===Cnf.isTablet) ? 3 : 4)))) {
                abandon=true;
            }
            
            this.oTilewall[arg.index].$expandable.attr('data-' + this.options.data.abandon,(true===abandon) ? 'true' : 'false');

            this.oTilewall[arg.index].$expandable.attr('data-' + this.options.data.notext, (true === arg.notext) ? 'true' : 'false');
            
            TweenMax.set(this.oTilewall[arg.index].$expandable, {
                height:'auto',
                position:'absolute',
                visibility:'hidden'
            });
            
            TweenMax.from(this.oTilewall[arg.index].$expandable, this.options.tween.open.duration, {
                height:0,
                ease:this.options.tween.open.ease,
                onStart:_.partial(function($el) {
                    TweenMax.set($el,{
                        position:'',
                        visibility:'visible'
                    });
                },this.oTilewall[arg.index].$expandable),
                onComplete:_.bind(function(){
                    this.oTilewall[arg.index].busy=false;
                },this)
            });
        };
        
        this.toggleExpandable=function($el)
        {
            var index=$el.data(this.options.data.index),
                    tileIndex=$el.data(this.options.data.tileIndex),
                    notext = $el.data(this.options.data.notext),
                    divider=(true===Cnf.isTablet) ? 3 : 4,
                    rest=(tileIndex % divider),
                    diff=divider -rest,
                    insertIndex=Math.min((tileIndex +diff), this.oTilewall[index].length) -1;
            
            this.oTilewall[index].$expandableHtml.html($el.find(this.options.selector.triggerHtml).html());
            
            //move to appropriate position
            this.oTilewall[index].$expandable.insertAfter(this.oTilewall[index].$tiles.eq(insertIndex));
            
            this.openExpandable({index:index,tileIndex:tileIndex, notext: notext});
        };
        
        this.closeExpandable=function(index)
        {
            var oDeferred=new $.Deferred();
            
            TweenMax.to(this.oTilewall[index].$expandable, this.options.tween.close.duration, {
                height:0,
                ease:this.options.tween.close.ease,
                onComplete:function() {
                    oDeferred.resolve();
                }
            });
            
            return oDeferred.promise();
        };
        
        this.disposeExpandable=function(index)
        {
            if(null!==this.oTilewall[index].$expandable) {
                this.oTilewall[index].$expandable.remove();
            }
            
            this.oTilewall[index].active=false;
            this.oTilewall[index].current=-1;
            this.oTilewall[index].busy=false;
            this.oTilewall[index].$expandable=null;
            this.oTilewall[index].$expandableHtml=null;
        };
        
        /**
         * callback on pubsub viewport change
         * 
         * @param {type} ev
         * @returns {undefined}
         */
        this.onViewportChange=function(ev)
        {
            switch(true) {
                case ev.current==='mobile':
                case ev.previous==='mobile':
                //rearrange expandable on feature request
                case (ev.previous==='tablet') && (ev.current==='desktop'):
                case (ev.previous==='desktop') && (ev.current==='tablet'):
                    for(var index=0;index<this.iTilewall;index++) {
                        
                        if(this.oTilewall[this.aRelation[index]].current>=0) {
                            this.oTilewall[this.aRelation[index]].$el.removeClass(this.options.classname.active);
                            this.oTilewall[this.aRelation[index]].$tiles.eq(this.oTilewall[this.aRelation[index]].current).removeClass(this.options.classname.activeTile);
                        }
                        
                        this.disposeExpandable(this.aRelation[index]);
                    }
                    break;
                    
                case (ev.previous==='tablet') && (ev.current==='desktop'):
                case (ev.previous==='desktop') && (ev.current==='tablet'):
                    //rearrange expandable here if feature is requested...
                    break;
                    
                default:break;
            }
        };
        
        this.init();
    };
});
